<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-row>
                  <b-col sm="6">
                    <b-button size="sm" variant="danger" v-on:click="deleteMainBanner()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 delete_button_on' : 'mx-1 delete_button_off'">
                      <h5 style="margin-bottom:0px">
                        <i class="fa fa-remove"></i> 삭제
                      </h5>
                    </b-button>
                  </b-col>
                  <b-col sm="6">
                    <b-form-select v-model="perPage" :options="pageOptions"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="12">
                <b-table striped hover :fields="fieldobj.fieldItems" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">

                  <div slot="table-busy" class="text-center my-2">
                    <div>
                      <strong>데이터가 없습니다.</strong>
                    </div>
                  </div>

                  <template slot="selectcheck" slot-scope="data" >
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>

                  <template slot="use_yn" slot-scope="data">
                    <div>
                      <c-switch type="text" :id="'useynSelect'+data.item.rnum" variant="primary" v-model="data.item.use_yn" v-on:change="TermsActiveYN(data.item, data.item.rnum)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>
                  </template>

                  <template slot="subject" slot-scope="data"s>
                    <div>
                      <a href="javascript:void(0)" v-on:click="termsInfoGo(data.item)">{{data.item.subject}}</a>
                    </div>
                  </template>

                </b-table>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/site/termsfrom/form?status=insert'">
            <i class="fa fa-hand-o-up"></i> 신규등록
          </b-button>
        </div>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>


import cSwitch from '../../../../components/Switch'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";
import swal from "sweetalert2";
const moment = require("moment");

export default {
  name: 'TermsList',
  props: {
    queryParams: {
      type: Object
    },
    fieldobj: {
      type: Object
    },
    fullDate: {
      type: Array
    },
    currentTab: {
      type: String
    },
  },

  components: {
    PulseLoader,
    cSwitch
  },
  data () {
    return {
      drDeleteRows: [],
      selectSlotNumbers: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      selectAll: false,
      slotParams: {},
      items: [],
    }
  },
  mounted() {
    this.queryParams.term_type = this.currentTab;
    this.findTermsManagementList();
  },
  methods: {
    // 검색 리스트 불러오기
    findTermsManagementList () {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();

      console.log('test >>>>',self.queryParams);

      data.append('objs', param);
      self.$http.post('/api/select/termsManagementList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          self.selectSlotNumbers = [];
          self.items.forEach(function (el, idx, arr){
            el.rnum = self.items.length - (idx);
            el.selectchecked = false;
            // 활성화된 배너면 관리를 위한 selectSlotNumbers 배열에 push
            if(el.active_yn == 'Y'){
              self.selectSlotNumbers.push(el);
            }
          });
        })
    },


    // 상세 페이지 이동, 배너코드 세션 세팅
    termsInfoGo (row) {
      var self = this;
      var url = '#/site/termsfrom/form?status=update';
      self.$session.set('term_id', row.term_id);
      location.href = url;
    },


    // 배너 활성화/비활성화
    TermsActiveYN (data, selectNum) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var newActive = items.use_yn;

      self.$http.get('/api/update/termActiveYn?access_token='+token + '&term_id='+items.term_id + '&use_yn='+newActive)
      .then((result) => {
        self.findMainManagementList();
      })
    },

    // 삭제 리스트 개별 선택
    drListRows () {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.drDeleteRows.push(el.term_id);
        }
      });
    },

    // 선택 베너 삭제
    deleteMainBanner () {
      var self = this;
      if (self.items.some(item => item.use_yn === 'Y' && self.drDeleteRows.includes(item.term_id))) {
        swal.fire(
          '활성화된 게시물은 삭제할 수 없습니다.',
          '',
          'error'
        ).then(function() {
          // callback function
        });
        return;
      }
      swal.fire({
        title: '게시물 삭제!',
        html: "<b>선택하신 게시물이 모두 삭제 됩니다.</br> 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          // console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);
          self.$http.post('/api/delete/terms?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '게시물이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findTermsManagementList();
              });
            })
        }else{
          // cansel
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/site/terms/component/TermsList.vue